import React, { memo } from 'react'

import { Drawer } from '@/components/Drawer/DrawerV2'
import SendToDocusign from './drawer/index'
import { useAppDispatch } from '@/client/hooks'

const DocusignDrawer = ({
  isOpen,
  setIsOpen,
  application,
  useDispatch = false,
  altFile = null,
}) => {
  const dispatch = useAppDispatch()

  const handleClose = (isOpen) => {
    if (!useDispatch) {
      setIsOpen(!isOpen ? null : isOpen)
    } else dispatch(setIsOpen(isOpen))
  }

  return (
    <Drawer
      title='Workflow / Send To DocuSign'
      isOpen={useAppDispatch ? !!isOpen : isOpen}
      setIsOpen={handleClose}
    >
      <SendToDocusign
        application={application}
        altFile={altFile}
        setIsOpen={handleClose}
      />
    </Drawer>
  )
}

export default memo(DocusignDrawer)
